<template>
  <div>
    <h3 class="mb-2 text-sm">Property:</h3>
    <input type="text" v-model="address" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" readonly @click="addressLookupOpen = true" />

    <address-lookup-modal
      v-if="addressLookupOpen"
      v-model="order"
      @leave="addressLookupOpen = false"
      name-number-key="property_address_name_number"
      street-key="property_address_line2"
      line3-key="property_address_line3"
      town-key="property_address_town"
      county-key="property_address_line4"
      postcode-key="property_address_postcode"
        />

    <div class="flex flex-wrap -mx-3 mt-8">
      <div class="w-full md:w-1/2 px-3 mb-8">
        <h3 class="mb-2 text-sm">Price:</h3>
        <div class="flex">
          <select v-model="order.price_qualifier_id" class="w-1/2 border hover:border-grey-darker focus:border-grey-darkest p-3">
            <option :value="0">Price</option>
            <option :value="1">Asking Price</option>
            <option :value="2">Fixed Price</option>
            <option :value="3">Price from</option>
            <option :value="4">Guide Price</option>
            <option :value="5">Offers in region of</option>
            <option :value="6">Offers in excess of</option>
            <option :value="8">Sale by Tender</option>
            <option :value="9">Shared Ownership</option>
            <option :value="10">Auction Guide Price</option>
            <option :value="12">Part Buy Part Rent</option>
            <option :value="13">Shared Equity</option>
            <option :value="14">Offers Over</option>
            <option :value="15">From</option>
          </select>
          <div class="p-3 bg-grey-light">
            £
          </div>
          <input type="number" min="0" v-model.number="order.guide_price" class="w-1/2 border hover:border-grey-darker focus:border-grey-darkest p-3" />
        </div>
      </div>

      <div class="w-full md:w-1/6 px-3">
        <h3 class="mb-2 text-sm">Bedrooms:</h3>
        <input type="number" min="0" v-model.number="order.bedrooms" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>

      <div class="w-full md:w-1/6 px-3">
        <h3 class="mb-2 text-sm">Bathrooms:</h3>
        <input type="number" min="0" v-model.number="order.bathrooms" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>

      <div class="w-full md:w-1/6 px-3">
        <h3 class="mb-2 text-sm">Receptions:</h3>
        <input type="number" min="0" v-model.number="order.reception_rooms" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
      </div>
      <div class="w-full md:w-1/4 px-3">
        <h3 class="mb-2 text-sm">Tenure:</h3>
          <select v-model="order.tenure_id" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3">
            <option :value="null" disabled>Select tenure</option>
            <option :value="0">Share Transfer</option>
            <option :value="1">Freehold</option>
            <option :value="2">Leasehold</option>
            <option :value="4">Commonhold</option>
            <option :value="5">Share of Freehold</option>
          </select>
      </div>
      <div class="w-full md:w-1/4 px-3">
        <h3 class="mb-2 text-sm">Council Tax Band:</h3>
          <select v-model="order.council_tax_band" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3">
            <option :value="null" disabled>Select a band</option>
            <option value="A">Band A</option>
            <option value="B">Band B</option>
            <option value="C">Band C</option>
            <option value="D">Band D</option>
            <option value="E">Band E</option>
            <option value="F">Band F</option>
            <option value="G">Band G</option>
            <option value="H">Band H</option>
            <option value="I">Band I</option>
          </select>
      </div>
      <div v-if="propertyEnums" class="w-full md:w-1/2 px-3">
        <h3 class="mb-2 text-sm">Property Type:</h3>
          <select v-model="order.property_type_id" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3">
            <optgroup v-for="(group, i) in propertyEnums.type" :key="i" :label="group.label">
              <option v-for="(type, j) in group.options" :key="j" :value="type.value">{{ type.label }}</option>
            </optgroup>
          </select>
      </div>
    </div>

    <hr class="border-b border-grey-lighter mb-6" />

    <h3 class="mb-2 text-sm">Vendor Details:</h3>
    <div class="flex flex-wrap -mx-3">
      <div class="w-full md:w-1/2 px-3">
        <fieldset class="border p-3 mb-6">
          <legend class="">Vendor 1 (Primary Contact)</legend>
          <div class="flex flex-wrap -mx-3 mb-6">
            <div class="w-1/3 px-3">
              <h4 class="mb-2 text-xs">Title:</h4>
              <select v-model="order.vendor1_title" class="w-full border hover:border-grey-darker p-3">
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Miss">Miss</option>
                <option value="Ms">Ms</option>
                <option value="Dr">Dr</option>
                <option value="Lord">Lord</option>
                <option value="Lady">Lady</option>
              </select>
            </div>
            <div class="w-2/3 px-3">
              <h4 class="mb-2 text-xs">Name:</h4>
              <input type="text" v-model="order.vendor1_name" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
            </div>
          </div>

          <div class="mb-6">
            <h4 class="mb-2 text-xs">Email Address:</h4>
            <input type="email" v-model="order.vendor1_email" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
          </div>

          <div>
            <h4 class="mb-2 text-xs">Contact Number:</h4>
            <input type="tel" v-model="order.vendor1_phone" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
          </div>

          <div class="mt-6" v-if="ehouseItems.length">
            <input type="checkbox" id="supplier_vendor_contact" v-model="order.supplier_vendor_contact" />
            <label for="supplier_vendor_contact" style="white-space: normal">Allow ehouse to contact the vendor directly</label>
          </div>
        </fieldset>

        <fieldset v-if="additionalContact || order.vendor2_name" class="border p-3 mb-6">
          <legend class="">Vendor 2</legend>
          <div class="flex flex-wrap -mx-3 mb-6">
            <div class="w-1/3 px-3">
              <h4 class="mb-2 text-xs">Title:</h4>
              <select v-model="order.vendor2_title" class="w-full border hover:border-grey-darker p-3">
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Miss">Miss</option>
                <option value="Ms">Ms</option>
                <option value="Dr">Dr</option>
                <option value="Lord">Lord</option>
                <option value="Lady">Lady</option>
              </select>
            </div>
            <div class="w-2/3 px-3">
              <h4 class="mb-2 text-xs">Name:</h4>
              <input type="text" v-model.trim="order.vendor2_name" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
            </div>
          </div>

          <div class="mb-6">
            <h4 class="mb-2 text-xs">Email Address:</h4>
            <input type="email" v-model="order.vendor2_email" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
          </div>

          <div>
            <h4 class="mb-2 text-xs">Contact Number:</h4>
            <input type="tel" v-model="order.vendor2_phone" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
          </div>
        </fieldset>
        <div v-else @click="additionalContact = true" class="text-blue hover:text-blue-dark underline text-center cursor-pointer">Add additional contact</div>
      </div>

      <div class="w-full md:w-1/2 px-3">
        <div class="mb-6">
          <h4 class="mb-2 text-xs">Reason for move:</h4>
          <select v-model="order.move_reason_id" class="w-full border hover:border-grey-darker p-3">
            <option :value="null">[Please Select]</option>
            <option :value="0">Looking to upsize/downsize</option>
            <option :value="1">Probate Sale</option>
            <option :value="2">Divorce</option>
            <option :value="3">Bereavement</option>
            <option :value="4">Investor Property</option>
            <option :value="5">Work Relocation</option>
            <option :value="6">Other (Please specify in notes)</option>
          </select>
        </div>

        <div class="mb-6">
          <h4 class="mb-2 text-xs">Notes for {{ selectedOffice.network_id === 2 ? 'Focal Agent' : 'ehouse' }}:</h4>
          <p v-if="selectedOffice.network_id === 7" class="mb-3 text-xs text-grey-dark">ehouse are the preferred supplier used to provide professional photos, floorplans, EPC’s etc. as part of the F&C Bespoke Marketing Suite.</p>
          <p v-else class="mb-3 text-xs text-grey-dark">Focal Agent are the preferred supplier used to provide Professional Photography, Floorplan, EPC’s, Drone Photography and Drone Video, as part of the Guild Marketing Packs.</p>
          <textarea v-model="order.notes" rows="8" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3 leading-normal" placeholder="e.g., photo preferences such as photographing a certain room or feature, outbuildings that require photographs or something the photographer may need to be aware of."></textarea>
        </div>

        <div class="mb-6" v-if="interviewOrderItem">
          <h4 class="mb-2 text-xs">Property Summary for Vendor Interview:</h4>
          <textarea v-model="order.interviewer_notes" rows="8" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3 leading-normal" placeholder="Please enter a brief summary of the property here, such as approximate age and any interesting features. This information helps the Vendor Interviewer to prepare for the interview."></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AddressLookupModal from '../../../components/AddressLookupModal'
import { find } from 'lodash'

export default {
  props: ['value', 'pack', 'ehouse-items'],
  components: {
    AddressLookupModal
  },
  data () {
    return {
      order: this.value,
      additionalContact: false,
      addressLookupOpen: false
    }
  },
  computed: {
    ...mapState(['selectedOffice', 'propertyEnums']),
    address () {
      return [
        [this.order.property_address_name_number, this.order.property_address_line2].filter(item => item).join(' '),
        this.order.property_address_line3,
        this.order.property_address_town,
        this.order.property_address_line4,
        this.order.property_address_postcode ? this.order.property_address_postcode.toUpperCase() : ''
      ].filter(item => item).join(', ')
    },
    interviewPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 5)
    },
    interviewOrderItem () {
      if (!this.interviewPackItem) {
        return null
      }

      return find(this.order.items, (item) => item.marketing_pack_item_id === this.interviewPackItem.id)
    }
  },
  created () {
    this.fetchPropertyEnums()
  },
  methods: {
    ...mapActions(['fetchPropertyEnums'])
  },
  watch: {
    order: {
      handler () {
        this.$emit('input', this.order)
      },
      deep: true
    }
  }
}
</script>
